import './Service.css'
// import Artificialintelligence from '../../assets/Artificialintelligence.png'
import {Link} from 'react-router-dom'

const ServiceComponent=(prop)=>{
    console.log(prop.servicepointlist)
    return(
        <div className='service-list-item'>
        <div className='service-list-item-icon'>
            <img src={prop.iconlink}/>
            
        </div>
        <p className='service-list-item-header'>{prop.serviceName}</p>
        <p className='service-list-item-text'>
        {prop.serviceDetails}
        </p>
        {/* <Link to={'/readmore'} style={{textDecoration:"none", textTransform:"none", marginTop:"1.5rem"}} >  <a className='service-list-item-read-more'>Read More</a></Link> */}
        <Link
            to="/readmore"
            state={{ serviceName: prop.serviceName, servicecontent : prop.serviceDetailspage,  serviceDetails : prop.serviceDetails, servicecoverimagelink : prop.servicecoverimagelink, servicepointlist: prop.servicepointlist, servicehighlightcoverimage:prop.servicehighlightcoverimage, listicon:prop.listicon }}  // No need for pathname object
            style={{ textDecoration: "none", textTransform: "none", marginTop: "1.5rem" }}
            >
            <span className='service-list-item-read-more'>Read More</span> 
            </Link>
    </div> 
    )
}

export default ServiceComponent;